export const chartBarColor = 'rgb(31, 134, 215)';
export const chartTextColor = 'rgb(145, 145, 145)';